const { countBy } = require("lodash");

const debug = false;
const initialMin = 60;
const initialMax = 100;

// SVG ICONS
const defaultIconSvg = `<?xml version="1.0" encoding="utf-8"?><!-- Generator: Adobe Illustrator 23.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 viewBox="0 0 10 10" style="enable-background:new 0 0 10 10;" xml:space="preserve"><style type="text/css">	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#3283CB;stroke-width:2;stroke-miterlimit:10;}</style><title>quadrato copy@1x</title><circle class="st0" cx="5" cy="5" r="3.8"/></svg>`;
const defaultIcon = new Image();
defaultIcon.src = 'data:image/svg+xml;base64,' + window.btoa(defaultIconSvg);
defaultIcon.width = 10;
defaultIcon.height = 10;


class OssimeterChart {

    constructor(el, options) {
        if(debug) {
            console.log('OssimeterChart: init in element with id \''+el+'\'', options);
        }

        this.container = document.getElementById(el);
        if(!this.container) {
            console.error('OssimeterChart: element with id \''+el+'\' not found', this.container);
            return;
        }

        this.options = options;

        const { data = [], fromDate, toDate, animation = true, showLine = false, fill = false } = options;

        this.fromDate = new Date(fromDate ?? '');
        this.toDate = new Date(toDate ?? '');

        this.showBpm = true; // Imposta la visibilità dei BPM, default: true

        // console.debug(startDate, endDate, this.startDate, this.endDate, this.startDate.getTime(), this.endDate.getTime())

        this.container.className = "chart-container";
        this.canvas = document.createElement("canvas");
        this.canvas.id = el+'_canvas';

        var ctx = this.canvas.getContext("2d");

        // COLORS & BACKGROUNDS
        // SPO2
        const colorSPO2 = 'rgb(50, 131, 203)';
        const color1Op = 'rgba(0, 133, 228, 0.2)';
        const color1Tr = 'rgba(0, 133, 228, 0)';
        const colorSPO2Alert = 'rgb(255, 94, 0)';
        const colorSogliaSPO2 = 'rgb(50, 131, 203, 0.7)';


        var backgroundGradient1 = ctx.createLinearGradient(0, 0, 0, 450);
        backgroundGradient1.addColorStop(0.7, color1Tr);
        backgroundGradient1.addColorStop(0, color1Op);

        // BPM
        const colorBPM = 'rgb(204, 67, 113)';
        const colorBPMAlert = 'rgb(255, 94, 0)';
        const color2Op = 'rgba(227, 132, 0, 0.2)';
        const color2Tr = 'rgba(227, 132, 0, 0)';
        const colorSogliaBPM = 'rgb(204, 67, 113, 0.5)';


        var backgroundGradient2 = ctx.createLinearGradient(0, 0, 0, 450);
        backgroundGradient2.addColorStop(0.7, color2Tr);
        backgroundGradient2.addColorStop(0, color2Op);

        // ICONS
        // BPM ICON
        let bpmIconSvg = `<svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 10 10" style="enable-background:new 0 0 10 10;" xml:space="preserve"> <style type="text/css">   .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FF3F73;}   </style>   <title>cerchio@1x</title>   <g id="cerchio">   <circle id="Oval" class="st0" cx="5" cy="5" r="5"/>   </g>   </svg>   `;
        let bpmIconAlertSvg = `<svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <title>cerchio@1x</title>    <g id="cerchio" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">        <circle id="Oval" fill="#FF5E00" cx="5" cy="5" r="5"></circle>    </g></svg>`;
        let bpmIcon = new Image();
        let bpmIconAlert = new Image();
        bpmIcon.src = 'data:image/svg+xml;base64,' + window.btoa(bpmIconSvg);
        bpmIconAlert.src = 'data:image/svg+xml;base64,' + window.btoa(bpmIconAlertSvg);
        bpmIcon.width = 10;
        bpmIcon.height = 10;
        bpmIconAlert.width = 10;
        bpmIconAlert.height = 10;

        this.container.appendChild(this.canvas);

        if(debug) {
            console.debug('ossimeter data', data);
        }

        this.convertData(data);

        // Setta le caratteristiche del grafico e i dati da visualizzare ( data: this.data1,)
        this.chart = new Chart(this.canvas.id, {
            type: 'line',
            data: {
                labels: this.getLabels(),// this.labels,
                datasets: [{
                    // SPO2
                    // barPercentage: 0.1,
                    borderColor: (data) => {
                        if((data.type == 'data') && (this.options?.thresholds?.enabled_threshold == 1)) {
                            if(
                                (this.options?.thresholds?.spo2MinValue && parseFloat(data.raw?.y) < parseFloat(this.options.thresholds.spo2MinValue))  ||
                                (this.options?.thresholds?.spo2MaxValue && parseFloat(data.raw?.y) > parseFloat(this.options.thresholds.spo2MaxValue)) 
                            ){
                                return colorSPO2Alert;
                            }
                        }
                        return colorSPO2;
                    },
                    borderWidth: 2,
                    radius: 3,
                    pointBackgroundColor: 'white',
                    data: this.data1,
                    fill: true,
                    backgroundColor: backgroundGradient1,
                    tension: 0,
                    // pointHoverBorderWidth: 0,
                    yAxisID: 'y1',
                    fill,
                    showLine,
                },
                {
                    // BPM - default: colorBPM,
                    // barPercentage: 0.1,
                    borderColor: (data) => {
                        if((data.type == 'data') && (this.options?.thresholds?.enabled_threshold == 1)) {
                            if(
                                (this.options?.thresholds?.bpmMinValue && parseFloat(data.raw?.y) < parseFloat(this.options.thresholds.bpmMinValue))  ||
                                (this.options?.thresholds?.bpmMaxValue && parseFloat(data.raw?.y) > parseFloat(this.options.thresholds.bpmMaxValue))
                            ) {
                                return colorBPMAlert;
                            }
                        }

                        return colorBPM;
                    },
                    borderWidth: 2,
                    radius: 3,
                    pointBackgroundColor: 'white',
                    data: this.data2,
                    backgroundColor: backgroundGradient2,
                    tension: 0,
                    // pointHoverBorderWidth: 0,
                    yAxisID: 'y2',
                    fill,
                    showLine,
                    pointStyle: (data) => {
                        if((data.type == 'data') && (this.options?.thresholds?.enabled_threshold == 1)) {
                            if(
                                (this.options?.thresholds?.bpmMinValue && parseFloat(data.raw?.y) < parseFloat(this.options.thresholds.bpmMinValue)) || 
                                (this.options?.thresholds?.bpmMaxValue && parseFloat(data.raw?.y) > parseFloat(this.options.thresholds.bpmMaxValue)) 
                            ) {
                                return [bpmIconAlert];
                            }
                        }
                        return [bpmIcon];
                    },
                }],
                thresholdsOss: [
                    [this.options?.thresholds?.spo2MinValue, colorSogliaSPO2, this.options?.thresholds?.enabled_threshold],
                    [this.options?.thresholds?.spo2MaxValue, colorSogliaSPO2, this.options?.thresholds?.enabled_threshold],
                    [this.options?.thresholds?.bpmMinValue, colorSogliaBPM, this.options?.thresholds?.enabled_threshold, true],
                    [this.options?.thresholds?.bpmMaxValue, colorSogliaBPM, this.options?.thresholds?.enabled_threshold, true],
                ],
            },
            options: {
                layout: {
                    padding: {
                        top: 25,
                    }
                },
                animation: animation,
                interaction: {
                    intersect: false,
                    //mode: 'index'
                    axis: 'xy',
                    mode: 'point',
                },
                plugins: {
                    legend: false,
                    tooltip: {
                        displayColors: false,
                        position: 'nearest',
                        callbacks: {
                            title: function(tooltipItems) {
                                return moment(tooltipItems[0].raw.x).format('DD/MM/YYYY HH:mm');
                            },
                            label: function(tooltipItem) {
                                return tooltipItem.dataset.mylabel+": "+tooltipItem.raw.y;
                            },
                            footer: (tooltipItems) => {
                                return '';
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        type: 'linear',
                        min: this.fromDate ? this.fromDate.getTime() : null,
                        max: this.toDate ? this.toDate.getTime() :  null,
                        grid: {
                            borderWidth: 0,
                            color: function(line) {
                                return false;
                            }
                        },
                        ticks: {
                            display: true,
                            stepSize: this.getStepSize(),
                            // color: '#999',
                            font: {
                                size: 12,
                            },
                            callback: (val, index) => {
                                // Hide the label of every 2nd dataset
                                // (return index % 2 === 0 ? moment(this.getLabelForValue(val)).format('DD/MM HH:mm') : '';

                                // console.log('callback', val, index, this.labels ? moment(this.labels[index]).format(this.getLabelFormat()) : null);

                                // Will display time in 10:30:23 format
                                // return this.data1 ? moment(val * 1000).format('DD/MM HH:mm') : null;
                                // return this.labels ? moment(this.labels[index]).format(this.getLabelFormat()) : null;
                                return this.labels ? moment(val).format(this.getLabelFormat()) : null;
                            },
                        },
                    },
                    y1: {
                        type: 'linear',
                        // position: 'left',
                        min: initialMin,
                        max: initialMax,
                        grid: {
                            borderWidth: 0,
                            borderDash: [4],
                            color: function(line) {
                                return "rgba(75,75,75,0.2)";
                            }
                        },
                        ticks: {
                            display: true, //this will remove only the label
                            stepSize: 10,
                            color: colorSPO2,
                            font: {
                                size: 12,
                            },
                            callback: function(value, index) {
                                return value + '  ';
                            }
                        },
                    },
                    y2: {
                        type: 'linear',
                        position: 'right',
                        min: 40,
                        max: 140,
                        grid: {
                            drawOnChartArea: false, // only want the grid lines for one axis to show up
                        },
                        ticks: {
                            display: true, //this will remove only the label
                            stepSize: 10,
                            color: colorBPM, // '#ccc',
                            font: {
                                size: 12,
                            },
                            callback: function(value, index) {
                                return '  ' + value;
                            }
                        }
                    },
                },
                responsive: true,
                maintainAspectRatio: true
            },
            plugins: [
                {
                    afterDatasetDraw: (chart) => {
                        let ctx = chart.ctx;
                        ctx.font = '12px Arial';
                        ctx.textBaseline = 'top';
                        ctx.textAlign = 'left';
        
                        const offsetWidth = ctx.canvas.offsetWidth;

                        // SPO2 
                        ctx.fillStyle = colorSPO2; // label color
                        ctx.fillText('SpO2', 34, 0);
                        this.drawCustomIcon(ctx, defaultIcon.src, 16, 0, 8, 8); // Disegna l'icona personalizzata

                        ctx.fillStyle = colorBPM; // label color
                        ctx.textAlign = 'right';
                        ctx.fillText('bpm', offsetWidth - 1, 0);
                        this.drawCustomIcon(ctx, bpmIcon.src, offsetWidth - 40, 0, 8, 8); // Disegna l'icona personalizzata

                    },
                    thresholdPlugin: {
                    },
                }
            ]
        });

        if(debug) {
            console.debug('ossimeter done', this.labels, this.data1, this.data2);
        }
    }

    convertData(data) {
        // this.labels = [];
        this.data1 = [];
        this.data2 = [];

        if(!!data && !!data.spo2) {
            for (const prop in data.spo2) {
                // console.log(`${prop} - ${data.spo2[prop]}`);
                // this.labels.push(prop);
                let millis = parseInt(prop) * 1000;
                this.data1.push({
                    y: data.spo2[prop],
                    x: millis
                });
                this.data2.push({
                    y: data.bpm[prop],
                    x: millis
                });
            }
        }

        if(debug) {
            console.debug('ossimeter convertData', this.data1, this.data2);
        }

        // if(this.labels.length == 0) {
        //     this.setDefaultLabels()
        // }
    }

    // Metodo per impostare la visibilità dei BPM
    setShowBpm(show) {
        this.showBpm = show;
        this.chart.data.datasets[1].hidden = !show; // Imposta la visibilità dei BPM
        this.chart.data.thresholdsOss[2][2] = show; // Imposta la visibilità della soglia minima dei BPM
        this.chart.data.thresholdsOss[3][2] = show; // Imposta la visibilità della soglia massima dei BPM
        this.chart.update();
    }

    setData(data, fromDate, toDate) {
        if(debug) {
            console.debug('ossimeterChart setData', this.chart, this.chart.scales, fromDate, toDate);
        }

        this.fromDate = new Date(fromDate);   
        this.toDate = new Date(toDate);

        this.chart.config.options.scales.x.min = this.fromDate.getTime();
        this.chart.config.options.scales.x.max = this.toDate.getTime();
        this.chart.config.options.scales.x.ticks.stepSize = this.getStepSize();

        this.convertData(data);

        this.chart.data.labels = this.getLabels();
        this.chart.data.datasets[0].data = this.data1;
        this.chart.data.datasets[0].mylabel = 'SpO2';

        // Update the BPM dataset only if showBpm is true
        if (this.showBpm) {
            this.chart.data.datasets[1].data = this.data2;
            this.chart.data.datasets[1].mylabel = 'bpm';
        } else {
            // If showBpm is false, set an empty array for the BPM dataset to hide it
            this.chart.data.datasets[1].data = [];
            this.chart.data.datasets[1].mylabel = '';
        }

        this.chart.update();
    }

    getLabels() {
        let date = new Date(this.fromDate);
        this.labels = [];
        // const debugs = [];

        while(date <= this.toDate) {
            this.labels.push(date.getTime());
            // date.setDate(date.getDate() + 1);
            date = new Date(date.getTime() + this.getStepSize());
            // debugs.push(moment(date.getTime()).format('DD/MM/YYYY HH:mm'));
        }

        // console.debug('labels', this.labels, debugs, this.fromDate, this.toDate);

        return this.labels;
    }

    getStepSize() {
        // console.debug('OSS. getStepSize', this.toDate - this.fromDate > 604800000 ? 86400000 : 14400000);
        return this.toDate - this.fromDate > 604800000 ? 86400000 : 14400000;
    }

    getLabelFormat() {
        // console.debug('getLabelFormat', this.fromDate, this.toDate, this.toDate - this.fromDate, 604800000 + 86400000, this.toDate - this.fromDate > 604800000 + 86400000);
        return this.toDate - this.fromDate > 604800000 + 86400000 ? 'DD/MM/YYYY' : 'DD/MM HH:mm';
    }

    toBase64Image(type, quality) {
        return this.chart.toBase64Image(type, quality);
    }

    // Funzione per disegnare un'icona personalizzata sul canvas
    drawCustomIcon(ctx, iconPath, x, y, width, height) {
        var img = new Image();
        img.src = iconPath;
        ctx.drawImage(img, x, y, width, height);
    }

}


var thresholdPlugin = {
    id: 'threshold',
    beforeDraw: function(chart, args) {

        let thresholdsWidth = 10;
        const shiftSoglia = 30;

        if (!chart.config.data.thresholdsOss) 
            return;

        // SPO2
        let yAxis = chart.scales['y1'];

        // SPO2 MIN
        if(chart.config.data.thresholdsOss[0][0] != undefined && chart.config.data.thresholdsOss[0][2] == 1 && yAxis != undefined){
            // console.log('thresholdPlugin', chart.config.data.thresholdsOss[0][0]);
            value = chart.config.data.thresholdsOss[0];
            let y = yAxis.getPixelForValue(value[0]);
            chart.ctx.beginPath();
            chart.ctx.moveTo(shiftSoglia, y);
            chart.ctx.lineTo(thresholdsWidth + shiftSoglia, y);
            chart.ctx.lineWidth = 2;
            chart.ctx.strokeStyle = value[1];
            chart.ctx.stroke();
        }

        // SPO2 MAX
        if(chart.config.data.thresholdsOss[1][0] != undefined && chart.config.data.thresholdsOss[1][2] == 1 && yAxis != undefined){
            // console.log('thresholdPlugin', chart.config.data.thresholdsOss[1][0]);
            value = chart.config.data.thresholdsOss[1];
            let y = yAxis.getPixelForValue(value[0]);
            chart.ctx.beginPath();
            chart.ctx.moveTo(shiftSoglia, y);
            chart.ctx.lineTo(thresholdsWidth + shiftSoglia, y);
            chart.ctx.lineWidth = 2;
            chart.ctx.strokeStyle = value[1];
            chart.ctx.stroke();
        }

        // BPM
        yAxis = chart.scales['y2'];

        // BPM MIN
        if(chart.config.data.thresholdsOss[2][0] != undefined && chart.config.data.thresholdsOss[2][2] == 1 && yAxis != undefined){
            // console.log('thresholdPlugin', chart.config.data.thresholdsOss[2][0]);
            value = chart.config.data.thresholdsOss[2];
            let y = yAxis.getPixelForValue(value[0]);
            chart.ctx.beginPath();
            chart.ctx.moveTo(chart.width - thresholdsWidth - shiftSoglia, y);
            chart.ctx.lineTo(chart.width - shiftSoglia, y);
            chart.ctx.lineWidth = 2;
            chart.ctx.strokeStyle = value[1];
            chart.ctx.stroke();
        }

        // BPM MAX
        if(chart.config.data.thresholdsOss[3][0] != undefined && chart.config.data.thresholdsOss[3][2] == 1 && yAxis != undefined){
            // console.log('thresholdPlugin', chart.config.data.thresholdsOss[3][0]);
            value = chart.config.data.thresholdsOss[3];
            let y = yAxis.getPixelForValue(value[0]);
            chart.ctx.beginPath();
            chart.ctx.moveTo(chart.width - thresholdsWidth - shiftSoglia, y);
            chart.ctx.lineTo(chart.width - shiftSoglia, y);
            chart.ctx.lineWidth = 2;
            chart.ctx.strokeStyle = value[1];
            chart.ctx.stroke();
        }

    }
};

// Aggiunge il plugin a Chart.js
Chart.register(thresholdPlugin);


window.OssimeterChart = OssimeterChart;